export default __webpack_public_path__ + "static/media/skarga.53bc0202.jpg";